import React, { Component } from 'react'
import { observer } from 'mobx-react'

import CompanyTable from './companytable'

@observer(['companies', 'globals'])
export default class Contacts extends Component {

  constructor(props) {
    super(props)

    if (this.props.companies.contacts.length == 0) {
      this.props.companies.loadAllContacts()
    }
  }

  reload(callback) {
    this.props.companies.loadAllContacts(() => {
      if (callback != null) {
        callback()
      }
    })
  }

  render() {
    return (
      <div>
        <CompanyTable companyTypeHeading={ 'Contact' } companyStateId={ 1 } data={ this.props.companies.contacts } reload={ this.reload.bind(this) } />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/companies/contacts.js